module.exports = __webpack_public_path__ + "static/media/DocBuilder-solutions-img.69011c69.png";